import { createSlice } from "@reduxjs/toolkit";

const now = Date.now() / 1000;

const statistics = {
  downLinkStats: [
    // Random usage from 1 kbps to 1000 kbps
    { "timestamp": now, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    // Random usage from 1000 bps to 10000 Kbps
    { "timestamp": now - 3600, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 7200, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 10800, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 14400, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 18000, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 21600, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 25200, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 28800, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 32400, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 36000, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 39600, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 43200, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 46800, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 50400, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 54000, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 57600, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 86400, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
  ],
  upLinkStats: [
    { "timestamp": now, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 3600, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 7200, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 10800, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 14400, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 18000, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 21600, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 25200, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 28800, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 32400, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 36000, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 39600, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 43200, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 46800, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 50400, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 54000, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
    { "timestamp": now - 57600, "value": Math.floor(Math.random() * (1000 - 1 + 1)) + 1 },
    { "timestamp": now - 80000, "value": Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 },
  ]
}

export const clientStatisticsSlice = createSlice({
  name: "clientStatistics",
  initialState: {
    statistics
  },
  reducers: {},
});

export default clientStatisticsSlice.reducer;
